// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader/dist/cjs.js?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-2155039a&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Shop/ShopPage.vue
// module id = 441
// module chunks = 0